"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakdownTypes = void 0;
exports.BreakdownTypes = {
    None: "none",
    Voice: "voice",
    VoiceMultiplier: "voice_multiplier",
    User: "user",
    Groups: "groups",
    ApiKeys: "api_keys",
    AllApiKeys: "all_api_keys",
    ProductType: "product_type",
    Model: "model",
    Resource: "resource",
    RequestQueue: "request_queue",
};
